import * as React from 'react'

import { Link, LinkProps } from './link'

export const ActionLink = ({ ...rest }: ActionLinkProps): JSX.Element => <Link href="#" role="button" {...rest} />

interface ActionLinkProps extends Omit<LinkProps, 'href'> {
    readonly onClick: () => void
}
